import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DlaService } from 'src/app/shared/dla.service';

@Component({
  selector: 'app-mobile-nav',
  templateUrl: './mobile-nav.component.html',
  styleUrls: ['./mobile-nav.component.css']
})
export class MobileNavComponent implements OnInit {

  constructor(
    private router: Router,
    private dlaService: DlaService) {
  }

  ngOnInit() {
    console.log('Got Here1');
  }

  logout() {
    console.log('Got Here');
    this.dlaService.loggedIn = false;
    localStorage.clear();
    this.router.navigate(['/login']);
  }

}
